import { Icon } from '@iconify/react/dist/iconify.js';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const InvoicePreviewLayer = ({data}) => {
  console.log(data)
    const [message, setMessage]= useState({
        status:false,
        reason:'',
        desc:''
    })
    const [showDiscount, setShowDiscount] = useState(false); // Tracks the currently editing field
    const [showTax, setShowTax] = useState(false); // Tracks the currently editing field
    const [editingField, setEditingField] = useState(null); // Tracks the currently editing field
    const [invoiceItems, setInvoiceItems] = useState(data?.items);
    const [discount, setDiscount] = useState(parseFloat(data?.discount)); // Discount in percentage
    
    const handleDiscountChange = (value) => {
        setDiscount(value);
    };
    const handleTaxChange = (value) => {
        setTaxAmount(value);
    };

    const calculateSubtotal = () =>{
        const subtotal = invoiceItems.reduce((acc, item) => acc + parseFloat(item.price), 0);
        return subtotal;
    }   

    const calculateDiscountedTotal = () => {
        const subtotal = calculateSubtotal();
        const discountAmount = (subtotal * discount) / 100;
        return subtotal - discountAmount;
    };
    const [taxAmount,setTaxAmount] = useState(parseFloat(data?.tax))
    const calculateTax = (total) => total * taxAmount / 100; // 10% tax

    const calculateTotal = () => {
        const discountedTotal = calculateDiscountedTotal();
        return discountedTotal + calculateTax(discountedTotal);
    };
    return (
        <div className="card">
            <div className="card-header">
                <div className="d-flex flex-wrap align-items-center justify-content-end gap-2">
                    <Link
                        to="#"
                        className="btn btn-sm btn-primary-600 radius-8 d-inline-flex align-items-center gap-1"
                    >
                        <Icon icon="pepicons-pencil:paper-plane" className="text-xl" />
                        Send Invoice
                    </Link>
                  
                    <Link
                        to={`/edit-invoice/${data?.id}`}
                        className="btn btn-sm btn-success radius-8 d-inline-flex align-items-center gap-1"
                    >
                        <Icon icon="uil:edit" className="text-xl" />
                        Edit
                    </Link>
                    <button
                        type="button"
                        className="btn btn-sm btn-danger radius-8 d-inline-flex align-items-center gap-1"

                    >
                        <Icon icon="basil:printer-outline" className="text-xl" />
                        Print
                    </button>
                </div>
            </div>
            <div className="card-body py-40">
                <div className="row justify-content-center" id="invoice">
                    <div className="col-lg-8">
                        <div className="shadow-4 border radius-8">
                            <div className="p-20 d-flex flex-wrap justify-content-between gap-3 border-bottom">
                                <div>
                                    <h3 className="text-xl">Invoice #{data?.invoice_number}</h3>
                                    <p className="mb-1 text-sm">Date Issued: {data?.issue_date}</p>
                                    <p className="mb-0 text-sm">Date Due: {data?.due_date}</p>
                                </div>
                                <div>
                                    <img src='./assets/images/logo.png' style={{width: 200}}/>
                                    <p className="mb-1 text-sm">
                                      {'London, United Kingdom'}
                                    </p>
                                    <p className="mb-0 text-sm">{'contact@rwires.co.uk'}</p>
                                    <p className="mb-0 text-sm">{''}</p>
                                </div>
                            </div>
                            <div className="py-28 px-20">
                                <div className="d-flex flex-wrap justify-content-between align-items-end gap-3">
                                    <div>
                                        <h6 className="text-md">Issus For:</h6>
                                        <table className="text-sm text-secondary-light">
                                            <tbody>
                                                <tr>
                                                    <td>Name</td>
                                                    <td className="ps-8">:{data?.customer_name}</td>
                                                </tr>
                                                <tr>
                                                    <td>Address</td>
                                                    <td className="ps-8">:{data?.address}</td>
                                                </tr>
                                                <tr>
                                                    <td>Phone number</td>
                                                    <td className="ps-8">:{data?.phone}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    
                                </div>
                                <div className="mt-24">
                                    <div className="table-responsive scroll-sm">
                                        <table className="table bordered-table text-sm">
                                            <thead>
                                                <tr>
                                                    <th scope="col" className="text-sm">
                                                        SL.
                                                    </th>
                                                    <th scope="col" className="text-sm">
                                                        Items
                                                    </th>
                                                    <th scope="col" className="text-sm">
                                                        Qty
                                                    </th>
                                                
                                                    <th scope="col" className="text-sm">
                                                        Unit Price
                                                    </th>
                                                    <th scope="col" className="text-end text-sm">
                                                        Price
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                            {
                                                    data?.items?.map((e,index)=>{
                                                        return(
                                                            <tr>
                                                                <td>{index+1}</td>
                                                                <td>{e.item_name}</td>
                                                                <td>{e.quantity}</td>
                                                                <td >£{e.unit_price}</td>
                                                                <td className='text-end'>£{parseFloat(e.price)}</td>
                                                            </tr>
                                                        );
                                                    })
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="d-flex flex-wrap justify-content-between gap-3">
                                        <div>

                                        </div>
                                        <div>
                                        <table className="text-sm">
                                                <tbody>
                                                    <tr>
                                                        <td className="pe-64">Subtotal:</td>
                                                        <td className="pe-16">
                                                            <span className="text-primary-light fw-semibold">
                                                            £{calculateSubtotal().toFixed(2)}
                                                            </span>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        
                                                        <td className="pe-64">Discount in %: </td>
                                                      {
                                                        showDiscount === true ? 
                                                      <td>
                                                     
                                                      <input
                                                            type="number"
                                                            className="form-control text-sm"
                                                            value={discount}
                                                            onChange={(e) =>
                                                                handleDiscountChange(Number(e.target.value))
                                                            }
                                                            placeholder="Enter discount"
                                                        />
                                                        
                                                      
                                                      </td>:

                                                        <td className="pe-16">
                                                            <span className="text-primary-light fw-semibold">
                                                            £{(
                                                        (calculateSubtotal() * discount) /
                                                        100
                                                    )}
                                                            </span>
                                                        </td>
                                                      }
                                                    </tr>
                                                    <tr>
                                                        <td className="pe-64 border-bottom pb-4">Tax:</td>

                                                        {
                                                        showTax === true ? 
                                                      <td>
                                                     
                                                      <input
                                                            type="number"
                                                            className="form-control text-sm"
                                                            value={taxAmount}
                                                            onChange={(e) =>
                                                                handleTaxChange(Number(e.target.value))
                                                            }
                                                            placeholder="Enter discount"
                                                        />
                                                        
                                                      
                                                      </td>:

                                                                <td className="pe-16 border-bottom pb-4">


                                                                <span className="text-primary-light fw-semibold">
                                                                £{calculateTax(calculateDiscountedTotal())}
                                                                </span>
                                                                </td>
                                                      }
                                                        
                                                    </tr>
                                                    <tr>
                                                        <td className="pe-64 pt-4">
                                                            <span className="text-primary-light fw-semibold">
                                                                Total:
                                                            </span>
                                                        </td>
                                                        <td className="pe-16 pt-4">
                                                            <span className="text-primary-light fw-semibold">
                                                            £{calculateTotal().toFixed(2)}
                                                            </span>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <div className="mt-64">
                                    <p className="text-center text-secondary-light text-sm fw-semibold">
                                        Thank you for your purchase!
                                    </p>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
};

export default InvoicePreviewLayer;